const filterButton = document.getElementById('filterButton');
// const filterForm = document.getElementById('filterForm');
const filterSubmit = document.getElementById('filterSubmit');
const filterWrapper = document.getElementById('filterWrapper');
const filterClear = document.getElementById('filterClear');
const filterCats = document.getElementById('filterCats');
const filterTags = document.getElementById('filterTags');

function getCheckedValues(wrapper) {
  return Array.from(wrapper.querySelectorAll('input[type="checkbox"]'))
    .filter((checkbox) => checkbox.checked)
    .map((checkbox) => checkbox.value)
    .join('+')
}


//check if filter button present
if(filterButton){
  //show and hide filter
  filterButton.addEventListener('click', function (e) {
    e.preventDefault();

    //check text in filter button and change accordingly
    if (filterButton.textContent === 'Close filter') {
      filterButton.textContent = 'Open filter';
    } else {
      filterButton.textContent = 'Close filter';
    }

    //change class of filter button
    filterButton.classList.toggle('lime-ghost');

    //hide filterWrapper

    filterWrapper.classList.toggle('hidden');
  });


  //Change url and reload based on filter params
  const urlParams = new URLSearchParams(window.location.search);

  filterSubmit.addEventListener('click', function (e) {
    e.preventDefault();

    if(filterCats) {
      if(getCheckedValues(filterCats)) {
        urlParams.set('cats', getCheckedValues(filterCats));
      } else {
        urlParams.set('cats', 'all');
      }
    }
   if(filterTags){
     if(getCheckedValues(filterTags)) {
       urlParams.append('tags', getCheckedValues(filterTags));
     } else {
       urlParams.delete('tags');
     }
   }
    window.location.search = urlParams;
  });

  //clear filter
  filterClear.addEventListener('click', function (e) {
    e.preventDefault();
    filterCats.querySelectorAll('input[type="checkbox"]').forEach(function(checkbox){
      checkbox.checked = false

      // urlParams.set('cats', 'all');
      urlParams.delete('tags');
      urlParams.delete('cats');
      window.location.search = urlParams;
    })
  });

  //check if cat params exist
  if(urlParams.get('cats')) {
    //check inputs that are active in filter
    let filter = urlParams.get('cats');
    let filterItems = filter.split("+")

    filterCats.querySelectorAll('input[type="checkbox"]').forEach(function(input) {
      if(filterItems.includes(input.value)){
        input.checked = true
      }
    });
  }

  //check if tag params exist
  if(urlParams.get('tags')) {
    //check inputs that are active in filter
    let filter = urlParams.get('tags');
    let filterItems = filter.split("+")

    filterTags.querySelectorAll('input[type="checkbox"]').forEach(function(input) {
      if(filterItems.includes(input.value)){
        input.checked = true
      }
    });
  }
}

